import { render, staticRenderFns } from "./userInfo.vue?vue&type=template&id=0af2334e&scoped=true&"
import script from "./userInfo.vue?vue&type=script&lang=js&"
export * from "./userInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af2334e",
  null
  
)

export default component.exports